import {h, Fragment} from "preact"
import { useFacets, useSort, useProductFilters } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import { sortOptions } from "../config"
import Select from "./elements/Select"
import SelectedFilters from "./SelectedFilters"

function ToggleSidebarButton({ className, onToggleSidebar }) {
    return (
        <button class="filter-sort__header-close box-content flex" style="width: 16px; height: 16px; padding: 4px;" onClick={onToggleSidebar}>
            <svg class="icon icon-close" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.49452 13.9999L14.4952 0.999947" stroke="currentColor"></path>
                <path d="M1.49522 1L14.4952 14" stroke="currentColor"></path>
            </svg>
        </button>
    )
}

function FilterRemoveButton({ filter, className, keyword }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-color-black ${className}`}
            style="padding: 0;"
            onClick={() => {
                filter.remove();
            }}
        >
            ×
        </button>
    )
}

function SideBarSelectedFilter() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="active-filter-wrapper">
                <div class="active-filter">Active filters</div>
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center gap-8 ns-selected-filters">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-d-flex ns-align-items-center gap-6"
                            style="background-color: #EAEAE6; padding: 2px 8px;"
                        >
                            <span class="ns-color-black text-14 font-light">{filter.value}</span>
                            <FilterRemoveButton filter={filter} keyword={filter.value}/>
                        </div>
                    ))}
                
                    <span
                        class=" ns-text-align-right ns-clear-all cursor-pointer"
                        style="border: 1px solid #d9d9d9; padding: 2px 8px;"
                        onClick={() => {
                            removeAll()
                        }}
                    >
                        Clear all
                    </span>
                </div>
            </div>
        )
    )
}

export default function SideBar({ toggleId, isActive, onToggleSidebar }) {
    const { loading, facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const handleSortChange = value => {
        setSort(value)
    }

    return facets?.length > 0 ? (
        <>
        
        <input type="checkbox" id={toggleId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class={`${isActive ? 'ns-active' : ''} ns-sidebar-wrapper ns-d-md-block ns-h-100`}
                // style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-overlay" onClick={onToggleSidebar}></div>
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline" style="border-bottom: 1px solid #EAEAE6">
                        <div class="text-16 font-light">Filters</div>
                        <ToggleSidebarButton onToggleSidebar={onToggleSidebar}/>
                    </div>
                    <div class="ns-sidebar-menu">
                        {/* <Select
                            value={activeSort}
                            onChange={handleSortChange}
                            className="ns-selection-dropdown-sort-menu"
                            options={options}
                        /> */}
                        <SideBarSelectedFilter />
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} />
                                    case "stats":
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    <div class="ns-sidebar-footer">
                        <button class="no-js-hidden ns-sidebar-footer-button" onClick={onToggleSidebar}>Done</button>
                        {/* <div class="filter-sort__footer sticky bg-white bottom-0 flex items-center justify-between gap-16">
                            <SelectedFilters />
                            <button class="no-js-hidden ns-sidebar-footer-button" onClick={onToggleSidebar}>Done</button>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
